module.exports = __webpack_public_path__ + "assets/img/discernment_id_card_scene2.491b56d5.png";